import React from "react";
import BrandManagerShell from "./components/BrandManagerShell";
import AccountPage from "./accountpage";

/**
 * Client Account surfaces hosted in Brand Manager (global control plane).
 * Same AccountPage SOR as the legacy brand-shell routes — no Brand copy.
 */
export default function BrandManagerAccount() {
  return (
    <BrandManagerShell>
      <AccountPage />
    </BrandManagerShell>
  );
}
